module.exports = __webpack_public_path__ + "static/media/naltrexone-initiation-for-opioid-use-disorder 09-22_FINAL.0b391603.pdf";